// DetailsModal.js
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import HttpClient from '../../utils/HttpClient';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import nothoto from "../../Images/nophoto.jpg"

const format1 = "DD-MM-YYYY, h:mm a"

Modal.setAppElement('#root'); // Set the root element for accessibility



const PostDetailsModal = ({ isOpen, closeModal, details }) => {


    const [tableData, setTableData] = useState([]);
    const [BcryptPassword, setBcryptPassword] = useState("")
    const navigate = useNavigate()

    const handleClickid = (id) => {
        navigate('/recently-added-user', { state: id })
    }

    // fetch Category DAta
    const getCategoryData = async () => {
        // setIsLoading(true);

        const res = await HttpClient.requestData('single-user/' + details, 'GET', {});
        if (res && res?.status) {
            const token = res?.data?.[0]?.token
            const decoded = jwtDecode(token);
            setTableData(res?.data);
            setBcryptPassword(decoded?.password)
        }
    }
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = tableData?.[0]?.qrCode;
        link.download = tableData?.[0]?.qrCode;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // useEffect(() => {
    //     getCategoryData();
    // }, [details]);
    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Details Modal"
            className=""
        >
            <a href='#' className='mtclose' onClick={closeModal}><i className="fa-solid fa-xmark"></i></a>


            <>
                <div className=' container'>
                    <div className=' row '>
                        <div className='col-12 d-flex justify-content-center '>
                            <h2 className='  border-bottom border-danger mb-3'>Post Details</h2>

                        </div>
                        <hr />
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Date & Time Created :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1)}</p>
                        </div> */}
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Subject:</h4>
                            <p className='mt-1'>{details?.subject || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Media :</h4>
                            <img src={details?.file || nothoto} alt="" id='preview'
                                style={{
                                    maxHeight: "256px",
                                }}
                            />
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Description:</h4>
                            <p className='mt-1'>{details?.description || "********"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Target Audience :</h4>
                            <p className='mt-1'>{details?.targetAudience?.join(" | ") || "N/A"}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Search Keywords :</h4>
                            <p className='mt-1'>{details?.searchKeywords?.join(", ") || "N/A"}</p>
                        </div>
                      
                        


                    </div>
                </div>
            </>


        </Modal >

    );
};

export default PostDetailsModal;
